import { useState } from "react";
import LayoutContext from "./layout-context";

type LayoutContextProviderProps = {
  children: React.ReactNode;
};

export const LayoutContextProvider: React.FC<LayoutContextProviderProps> = ({
  children,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuLocked, setMenuLocked] = useState(false);

  const [subMenuOpen, setSubMenuOpen] = useState(false);

  const [activeView, setActiveView] = useState("contactInfo");

  return (
    <LayoutContext.Provider
      value={{
        menuOpen,
        setMenuOpen,
        menuLocked,
        setMenuLocked,
        subMenuOpen,
        setSubMenuOpen,
        activeView,
        setActiveView,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
